var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWagonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C19.5523 1.28851e-07 20 0.447715 20 1V9H21V2C21 1.44772 21.4477 1 22 1H23C24.6568 1 25.9999 2.34325 26 4V8C25.5 8 25 8.5 25 9H26V9.99902C26 10.5513 25.5523 11 25 11H24.7305C24.3845 11.5973 23.7399 12 23 12C22.2601 12 21.6155 11.5973 21.2695 11H18.7305C18.3845 11.5973 17.7399 12 17 12C15.8954 12 15 11.1046 15 10C15 9.63536 15.0991 9.29437 15.2695 9H9V10C9 11.1046 8.10457 12 7 12C5.89543 12 5 11.1046 5 10C5 11.1046 4.10457 12 3 12C1.89543 12 1 11.1046 1 10V9H0V1C0 0.447715 0.447715 8.05319e-09 1 0H19ZM3 9C2.44772 9 2 9.44771 2 10C2 10.5523 2.44772 11 3 11C3.55228 11 4 10.5523 4 10C4 9.44771 3.55228 9 3 9ZM7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9ZM17 9C16.4477 9 16 9.44771 16 10C16 10.5523 16.4477 11 17 11C17.5523 11 18 10.5523 18 10C18 9.44771 17.5523 9 17 9ZM23 9C22.4477 9 22 9.44771 22 10C22 10.5523 22.4477 11 23 11C23.5523 11 24 10.5523 24 10C24 9.44771 23.5523 9 23 9ZM23 6H25V4C25 3.44772 24.5523 3 24 3H23V6Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagonIcon);
export default __webpack_public_path__ + "static/media/wagon-icon.6e41ac9fed74d0fb604acce3c4023ef4.svg";
export { ForwardRef as ReactComponent };